// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://dquqgmxxckztfnihscbe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRxdXFnbXh4Y2t6dGZuaWhzY2JlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM2OTAxODUsImV4cCI6MjA1OTI2NjE4NX0.AcI4czxsI2Z9MSJB0RY2PFM604r9g_Nq--nhVXVgzG0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);